<template>
  <Bar
    :id="chartId"
    :options="chartOptions"
    :data="chartData"
  />
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Tooltip, BarElement, PointElement, CategoryScale, LinearScale } from 'chart.js'
import * as formatUtils from '../../composables/formatUtils'

ChartJS.register(BarElement, Tooltip, PointElement, CategoryScale, LinearScale)

export default {
  name: 'KPIPeriodSingleChart',
  components: { Bar },
  props: ['chartId', 'period'],
  data () {
    return {
      chartData: {
        labels: [this.$t('views.kpi.edit.actualPY'), this.$t('views.kpi.edit.actual'), this.$t('views.kpi.edit.forecast'), this.$t('views.kpi.edit.plan'), this.$t('views.kpi.edit.objective')],
        datasets: [{
          data: [this.unFormatNumber(this.period.actualPrev), this.unFormatNumber(this.period.actual), this.unFormatNumber(this.period.forecast), this.unFormatNumber(this.period.plan), this.unFormatNumber(this.period.objective)],
          backgroundColor: ['#6c80bb', '#6c80bb', '#6c80bb73', '#bfbfbf', '#dc3545']
        }]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: {
            display: false
          }
        }
      }
    }
  },
  methods: {
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    }
  }
}
</script>
